import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import CameraIcon from '@material-ui/icons/PhotoCamera';
import CssBaseline from '@material-ui/core/CssBaseline';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import Main from './Main';
import ExampleWithLightbox from './ExampleWithLightbox';
import { Route, Switch } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Your Website
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 6),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
}));

const Album = () => {
  const classes = useStyles();
  const history = useHistory();

  const photos1 = [
    {
      src: 'images/103-0345-IMG.jpg',
      width: 4,
      height: 3 
    },
    {
      src: 'images/103-0348-IMG.jpg',
      width: 3,
      height: 4
    },
    {
      src: 'images/Engagement.jpg',
      width: 4,
      height: 3
    },
    {
      src: 'images/IMG_2016dj800.jpg',
      width: 4,
      height: 3 
    },
    {
      src: 'images/IMG_2017cmyj800.jpg',
      width: 4,
      height: 3
    },
    {
      src: 'images/IMG_2020yd800.jpg',
      width: 4,
      height: 3 
    },
    {
      src: 'images/IMG_2013sd800.jpg',
      width: 4,
      height: 3
    },
    {
      src: 'images/IMG_2025name800.jpg',
      width: 4,
      height: 3
    },
    {
      src: 'images/IMG_2022aunt800.jpg',
      width: 4,
      height: 3
    },
    {
      src: 'images/IMG_2024gift800.jpg',
      width: 4,
      height: 3
    },
    {
      src: 'images/IMG_2026g1-800.jpg',
      width: 4,
      height: 3
    },
    {
      src: 'images/IMG_2027g2-800.jpg',
      width: 4,
      height: 3
    },
    {
      src: 'images/IMG_2028g3-800.jpg',
      width: 4,
      height: 3
    }
  ];

  const photos2 = [
    {
      src: 'julia/IMG_0882.jpg',
      width: 4,
      height: 3 
    },
    {
      src: 'julia/IMG_0898.jpg',
      width: 4,
      height: 3
    },
    {
      src: 'julia/IMG_0902.jpg',
      width: 4,
      height: 3 
    },
    {
      src: 'julia/IMG_0905.jpg',
      width: 4,
      height: 3
    },
    {
      src: 'julia/IMG_0909.jpg',
      width: 3,
      height: 4
    },
    {
      src: 'julia/IMG_0915.jpg',
      width: 4,
      height: 3
    },
    {
      src: 'julia/IMG_0918.jpg',
      width: 4,
      height: 3
    },
    {
      src: 'julia/IMG_0929.jpg',
      width: 4,
      height: 3
    },
    {
      src: 'julia/IMG_0933.jpg',
      width: 4,
      height: 3
    },
    {
      src: 'julia/IMG_0934auto.jpg',
      width: 4,
      height: 3
    },
    {
      src: 'julia/IMG_0950.jpg',
      width: 4,
      height: 3
    },
    {
      src: 'julia/IMG_0952.jpg',
      width: 3,
      height: 4
    },
    {
      src: 'julia/IMG_0955.jpg',
      width: 4,
      height: 3
    },
    {
      src: 'julia/IMG_0956.jpg',
      width: 3,
      height: 4
    },
    {
      src: 'julia/IMG_0958a.jpg',
      width: 3,
      height: 4
    },
    {
      src: 'julia/IMG_0959a.jpg',
      width: 3,
      height: 4
    },
    {
      src: 'julia/IMG_0966w.jpg',
      width: 3,
      height: 4
    },
    {
      src: 'julia/IMG_0964a.jpg',
      width: 3,
      height: 4
    },
    {
      src: 'julia/IMG_0965w.jpg',
      width: 3,
      height: 4
    }
  ];

  const goHome = () => {
    history.push('/');
  }
  return (
    <React.Fragment>
      <CssBaseline />
      <AppBar position="relative">
        <Toolbar>

          <CameraIcon onClick={goHome} className={classes.icon} />

          <Link href="/" variant="h6" color="inherit" noWrap>
            Home
          </Link>
        </Toolbar>
      </AppBar>

      <div>
      <Switch>
        <Route path="/" component={Main} exact />
        <Route path="/galleryOne">
          <ExampleWithLightbox galleryId={1} title={'Photos from 2002 & 2006 Korea trip and more.'}/>
        </Route>
        <Route path="/galleryTwo">
          <ExampleWithLightbox galleryId={2} title={"Photos from 2004 Odilia's visit."} />
        </Route>
      </Switch>

      </div>
      
      {/* Footer */}
      <footer className={classes.footer}>
        <Typography variant="h6" align="center" gutterBottom>
          Youn's Album
        </Typography>
        <Typography variant="subtitle1" align="center" color="textSecondary" component="p">
          Photo Galleries 
        </Typography>
        <Copyright />
      </footer>
      {/* End footer */}
    </React.Fragment>
  );
}

export default Album;
